import Vue from 'vue';
export const Event = new Vue();

export default {
    avatarChange(avatar) {
        Event.$emit('avatar', avatar);
    },
    updateComment(comments) {
        Event.$emit('updateComment', comments);
    },

    updatePedido(pedido){
        Event.$emit('updatePedido', pedido);
    },
    chartClick(data) {
        +Event.$emit('chartClick', data);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/events.js